import React from "react";
import '../assets/styles/Map.scss';

function ClinicMap(data) {
  return data.clinic ? (
    <iframe title="clinicMap" src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_API_KEY}&q=${data.clinic.latitude},${data.clinic.longitude}`} className="w-100 h-100" frameBorder="0" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
  ) : <div>loading...</div>;
}

export default ClinicMap;
